import { render, staticRenderFns } from "./MemberScoreComponent.vue?vue&type=template&id=cb74e5f8&"
import script from "./MemberScoreComponent.vue?vue&type=script&lang=js&"
export * from "./MemberScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberScoreComponent.vue?vue&type=style&index=0&id=cb74e5f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports